import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getSampleQuizId } from 'libs/api/learning';
import { TModalProps } from 'modules/types';
import { ERoute } from 'enums/route.enum';
import { Modal, Button, Row } from 'antd';
import extendTicket from 'assets/images/pages/ticket/extendTicket.webp';

const ExtensionAlertModal = ({ modalState, setModalState }: TModalProps) => {
  const [sampleId, setSampleId] = useState<number>();
  const history = useHistory();

  function handleCancel() {
    setModalState({ visible: false });
  }

  const getSampleQuiz = async () => {
    const { success, data } = await getSampleQuizId();
    if (success) {
      setSampleId(data.sample_quiz_id);
    }
  };

  useEffect(() => {
    if (modalState.visible) {
      getSampleQuiz();
    }
  }, [modalState]);

  return (
    <Modal
      visible={modalState.visible}
      maskClosable={true}
      onCancel={handleCancel}
      width={600}
      centered={true}
      title={
        <div style={{ marginTop: '20px' }}>
          <span
            style={{
              fontSize: '1.75rem',
              fontWeight: 'bolder',
            }}
          >
            Career Step 패스가 만료되었습니다
          </span>
        </div>
      }
      footer={
        <Row justify='space-between'>
          <Button
            onClick={() => {
              if (sampleId) {
                history.push(`/case/quiz/view/${sampleId}`);
                handleCancel();
              }
            }}
          >
            샘플 문제 풀기 (무료)
          </Button>
          <div>
            <Button onClick={handleCancel}>닫기</Button>
            <Button className='ant-btn-primary' onClick={() => history.push(ERoute.CSLearningPurchasePage)}>
              3개월 연장하기
            </Button>
          </div>
        </Row>
      }
    >
      <div style={{ textAlign: 'center' }}>지금 연장 시 33% 할인된 가격으로 만나볼 수 있습니다.</div>
      <div style={{ width: '100%', textAlign: 'center', margin: '16px auto' }}>
        <img alt='ticket' src={extendTicket} />
      </div>
    </Modal>
  );
};

export default ExtensionAlertModal;
